export const MarketViewActionUnavailableReason = {
	ACL_EDITOR_REQUIRED: "ACL_EDITOR_REQUIRED",
	ACL_OWNER_REQUIRED: "ACL_OWNER_REQUIRED",
} as const;

export type MarketViewActionUnavailableReason =
	(typeof MarketViewActionUnavailableReason)[keyof typeof MarketViewActionUnavailableReason];

export const MarketViewListAction = {
	delete: "delete",
	share: "share",
} as const;

export type MarketViewListAction = (typeof MarketViewListAction)[keyof typeof MarketViewListAction];
